import {authenticationService} from './authenticationService';

export function authHeader() {
    // return authorization header with jwt token
    if (authenticationService.token) {
        const tk = JSON.parse(authenticationService.token);
        return { Authorization: `DIYHL ${tk.jwtToken}` };
    } else {
        return {};
    }
}